import { FC } from 'react';

import { Checkbox, Typography } from 'enable-ui';

import { CollapseWrapper } from 'modules/learners/component/on-boarding/CollapseWrapper';

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as DownIcon } from 'assets/icons/collapse-down.svg';
import { ReactComponent as UpIcon } from 'assets/icons/up.svg';

import { PermissionItem, RoleItem } from '../core/type';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const RolePermission: FC<{
  permissions: PermissionItem[];
  roles: RoleItem[];
  selectedPermissions: { roleId: number; permissionId: string }[];
  isEdit: boolean;
  handleChangePermission: (roleId: number, permissionId: string) => void;
}> = ({ permissions, roles, selectedPermissions, isEdit, handleChangePermission }) => {
  const headerStyle = {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    color: COLOR_CONFIG['neutral-text'],
  };

  const numberOfRoles = roles?.length;

  return (
    <div
      style={{
        border: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
        borderRadius: 12,
        padding: 16,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 48,
          borderRadius: 12,
          backgroundColor: COLOR.neutral['neutral-3-1'],
          padding: '0 16px',
        }}
      >
        <div style={{ width: '30%' }}>
          <Typography style={{ ...headerStyle }}>Permissions</Typography>
        </div>
        {roles?.map((role, index) => {
          return (
            <Typography
              key={index}
              style={{
                ...headerStyle,
                width: `calc(70% / ${numberOfRoles})`,
                textAlign: 'center',
              }}
            >
              {role.name}
            </Typography>
          );
        })}
      </div>
      {permissions?.map((permission, index) => {
        return (
          <CollapseWrapper
            defaultShow={false}
            visible={false}
            key={index}
            renderHeader={(show) => (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #0000001A',
                  cursor: 'pointer',
                  padding: '0 16px',
                  height: 50,
                }}
              >
                <div style={{ width: '30%', display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 8,
                    }}
                  >
                    {show ? (
                      <UpIcon style={{ width: 16, height: 16 }} />
                    ) : (
                      <DownIcon style={{ width: 16, height: 16 }} />
                    )}
                  </div>
                  <Typography
                    style={{
                      fontSize: 16,
                      lineHeight: '22px',
                      color: COLOR.surfaceNeutralBold['neutral-11'],
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {permission.name}
                  </Typography>
                </div>
                {roles?.map((role) => {
                  const checked = selectedPermissions.find(
                    (el) => el.roleId === role.id && el.permissionId === permission.id,
                  )
                    ? true
                    : false;

                  const disableCheckbox = permission.name === 'Home';

                  return (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: `calc(70% / ${numberOfRoles})`,
                      }}
                    >
                      {isEdit ? (
                        <Checkbox
                          checked={checked}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (disableCheckbox) return;
                            handleChangePermission(role.id, permission.id);
                          }}
                          disabled={disableCheckbox}
                        />
                      ) : checked ? (
                        <CheckIcon />
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
            body={
              <div>
                {permission.description.map((el, idx) => (
                  <Typography
                    style={{
                      fontSize: 14,
                      lineHeight: '20px',
                      color: COLOR.surfaceNeutralBold['neutral-11'],
                      padding: '14px 16px',
                      borderBottom: '1px solid #0000001A',
                      background: '#F9F9F9',
                      paddingLeft: 48,
                    }}
                    key={idx}
                  >
                    {el}
                  </Typography>
                ))}
              </div>
            }
          />
        );
      })}
    </div>
  );
};
